const BasicThemeJson = {

    'ColorPallete' : [
        {'colorName': 'Black', 'colorCode' : '#222222' , 'backgroundColor' : '#222222', borderRadius : '2px 0px 0px 2px', 'index': 0},
        {'colorName': 'Dark Grey', 'colorCode' : '#4D4D4D','backgroundColor' : '#4D4D4D', 'index': 1},
        {'colorName': 'Light Grey', 'colorCode' : '#E0E0E0', 'backgroundColor' : '#E0E0E0', 'index': 2},
        {'colorName': 'White', 'colorCode' : '#FFFFFF', 'backgroundColor' : '#FFFFFF', 'index': 3},
        {'colorName': 'Tint 2 of Primary', 'colorCode' : '#685AC014', 'backgroundColor' : '#685AC014', 'index': 4},
        {'colorName': 'Tint 1 of Primary', 'colorCode' : '#685AC029', 'backgroundColor' : '#685AC029', 'index': 5},
        {'colorName': 'Secondary', 'colorCode' : '#AE2BC6', 'backgroundColor' : '#AE2BC6', 'index': 6},
        {'colorName': 'Primary', 'colorCode' : '#685AC0', 'backgroundColor' : '#685AC0', borderRadius : '0px 2px 2px 0px', 'index': 7}
    ],
    'PresetColors' : ['#222222', '#4D4D4D', '#E0E0E0', '#FFFFFF', '#685AC014', '#685AC029', '#AE2BC6', '#685AC0'],
    'HeaderColor' : [
                     {'key' : 'TabSelectionsHeaderColor' ,'label' : 'Tab Selections', 'themeKey' : 'BasicTheme',
                        
                    'imgSrc' : require('../../../../../../Icons/TabSelection.svg'),
                    'imgSrc1' : require('../../../../../../Icons/TabSelection1.svg')
                    },
                 {'key' : 'SectionHeaderColor','label' : 'Section Heading','themeKey' : 'SectionStyle',
                            ////
                    'imgSrc' : require('../../../../../../Icons/SectionHeading.svg'),
                    'imgSrc1' : require('../../../../../../Icons/SectionHeading1.svg')
                    },
                 {'key' : 'ButtonsHeader','label' : 'Buttons', 'themeKey' : 'ButtonStyle',
                            ////
                    'imgSrc' : require('../../../../../../Icons/Buttons.svg'),
                    'imgSrc1' : require('../../../../../../Icons/Buttons.svg')
                    },
                 {'key' : 'ActiveStates','label' : 'Active States','themeKey' : 'ActiveStateStyle',
                            ////
                    'imgSrc' : require('../../../../../../Icons/ActiveStates.svg'),
                    'imgSrc1' : require('../../../../../../Icons/ActiveStates.svg')

                    },
                {'key' : 'InactiveStates','label' : 'Inactive States','themeKey' : 'InactiveStateStyle',
                            ////
                    'imgSrc' : require('../../../../../../Icons/InactiveStates.svg'),
                    'imgSrc1' : require('../../../../../../Icons/InactiveStates.svg')

                    },
                 {'key' : 'WizardSelecion','label' : 'Wizard Selection','themeKey' : 'WizardStyle',
                            ////
                    'imgSrc' : require('../../../../../../Icons/Wizards.svg'),
                    'imgSrc1' : require('../../../../../../Icons/Wizards.svg')
                                    },
                 {'key' : 'SlideBarHeader','label' : 'Slide Bar', 'themeKey' : 'SlideBarStyle',
                            ////
                    'imgSrc' : require('../../../../../../Icons/SlideBar.svg'),
                    'imgSrc1' : require('../../../../../../Icons/SlideBar1.svg')
                    }

                ],
        'GroupedColor' : [
            {'' : [
                {'key':'ActiveTextColor', 'label' : 'Active Text Color', 'themeKey' : 'BasicTheme',
                'imgSrc' : require('../../../../../../Icons/Font.svg'),
                'imgSrc1' : require('../../../../../../Icons/Font.svg'),
                'imgStyle' : {'width': '16px', 'height':'16px '}},
                {'key':'InactiveTextColor', 'label' : 'Inactive Text Color', 'themeKey' : 'BasicTheme',
                'imgSrc' : require('../../../../../../Icons/Font.svg'),
                'imgSrc1' : require('../../../../../../Icons/Font.svg'),
                'imgStyle' : {'width': '16px', 'height':'16px '}},
                ]
            },
            {'Background Color' : [
                {'key':'PageBackgroundColor', 'label' : 'Page', 'themeKey' : 'PageStyle'},
                {'key':'SectionBackgroundColor', 'label' : 'Sections', 'themeKey' : 'SectionStyle'},
                {'key':'TabBackgroundColor', 'label' : 'Tabs Horizontal', 'themeKey' : 'HorizontalTabStyle'},
                {'key':'WizardBackgroundColor', 'label' : 'Wizards', 'themeKey' : 'WizardStyle'},
                {'key':'TileBackgroundColor', 'label' : 'Tiles', 'themeKey' : 'TileStyle'}
                ]
            }
        ],
        'TextStyle' : [
            {'FontFamily' : {'key' : 'FontFamily', 'label' : 'Font Family'}, 'themeKey' : 'TextStyle'},
            {'TextSizes' : {'key' : 'FontSize', 'label' : 'Text Sizes'}, 'themeKey' : 'TextStyle'}
        ],
        'Spacing'  :[
            {'children' : [
                {'label' : 'Compressed', 'imgSrc' : require('../../../../../../Icons/Compressed_New.svg'), 'key' : 'Spacing', 'value':'2.5px'},
                {'label' : 'Compact', 'imgSrc' : require('../../../../../../Icons/Compact_New.svg'), 'key' : 'Spacing', 'value':'2.5px'},
                {'label' : 'Regular', 'imgSrc' : require('../../../../../../Icons/Regular_New.svg'), 'key' : 'Spacing', 'value':'5px'},
                {'label' : 'Expand', 'imgSrc' : require('../../../../../../Icons/Expand_New.svg'), 'key' : 'Spacing', 'value':'7.5px'},
                {'label' : 'Spacious', 'imgSrc' : require('../../../../../../Icons/Spacious_New.svg'), 'key' : 'Spacing', 'value':'7.5px'}
            ]}
        ],
        "Custom Spacing": 
            [
              { Title: "4",  Value: "4px" },
              { Title: "8",  Value: "8px" },
              { Title: "12",  Value: "12px" },
              { Title: "16",  Value: "16px" },
              { Title: "20",  Value: "20px" },
              { Title: "24",  Value: "24px" },
              { Title: "28",  Value: "28px" },
              { Title: "32",  Value: "32px" },
              { Title: "36",  Value: "36px" },
              { Title: "40",  Value: "40px" },
              { Title: "44",  Value: "44px" },
              { Title: "48",  Value: "48px" },
            ],
          
                
}

export default BasicThemeJson;
